import React, { Component } from 'react';
import { FormGroup, InputGroup, FormControl } from 'react-bootstrap'
import { connect } from 'react-redux'
import { checkPromoCode, clearPromoCode } from '../actions'
class PromoCode extends Component {
    state = {
        code: '',
        validPromoCode: '',
        wording: '',
        loading: false,
    }
    renderLoader() {
        return (
            <div style={{ display: 'inline-block' }}>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
            </div>
        )
    }
    callback(wording) {
        this.setState({ validPromoCode: true, loading: false, promocodeWording: wording })
    }
    callbackInvalidPromoCode(wording) {
        this.setState({ validPromoCode: false, loading: false, promocodeWording: wording })
        this.props.clearPromoCode()
    }
    callbackerr() {
        window.alert('เกิดข้อผิดพลาด promocode')
    }
    onSubmit() {
        let user = JSON.parse(localStorage.getItem('user'))
        this.setState({ loading: true })
        this.props.checkPromoCode(this.state.code, this.props.money, user.token, this.callback.bind(this), this.callbackInvalidPromoCode.bind(this), this.callbackerr)
    }
    render() {
        return (
            <div>
                <h4>{'ส่วนลด: ' + (this.props.discount.value || 0.00) + ' บาท'}</h4>
                <h5><strong>PromoCode</strong></h5>
                <FormGroup>
                    <InputGroup>
                        <InputGroup.Addon>{this.state.validPromoCode === '' ? '' : this.state.validPromoCode ? <span className='fa fa-check-circle'></span> : <span style={{ color: 'red' }} className='fa fa-times-circle'></span>}</InputGroup.Addon>
                        <FormControl value={this.state.code} onChange={(e) => { this.setState({ code: e.target.value }) }} type="text" />
                        <InputGroup.Addon disabled={this.state.loading} style={{ cursor: 'pointer' }} onClick={() => { this.onSubmit() }}>{this.state.loading ? this.renderLoader() : 'ตรวจสอบ'}</InputGroup.Addon>
                    </InputGroup>
                </FormGroup>
                <p style={{ color: this.state.validPromoCode == true ? 'green' : 'red' }}>
                    {this.state.promocodeWording}
                </p>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        discount: state.promocodeReducer,
    }
}
export default connect(mapStateToProps, { checkPromoCode, clearPromoCode })(PromoCode)


// WEBPACK FOOTER //
// ./src/components/component_promocode.js